function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18 1.58334C16.8065 1.58334 15.6619 2.08379 14.818 2.97459C13.9741 3.86538 13.5 5.07357 13.5 6.33334V19C13.5 20.2598 13.9741 21.468 14.818 22.3588C15.6619 23.2496 16.8065 23.75 18 23.75C19.1935 23.75 20.3381 23.2496 21.182 22.3588C22.0259 21.468 22.5 20.2598 22.5 19V6.33334C22.5 5.07357 22.0259 3.86538 21.182 2.97459C20.3381 2.08379 19.1935 1.58334 18 1.58334V1.58334Z",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.5 15.8333V19C28.5 21.9395 27.3938 24.7586 25.4246 26.8371C23.4555 28.9156 20.7848 30.0833 18 30.0833C15.2152 30.0833 12.5445 28.9156 10.5754 26.8371C8.60625 24.7586 7.5 21.9395 7.5 19V15.8333",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18 30.0833V36.4167",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 36.4167H24",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgMictwo = function SvgMictwo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMictwo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mictwo.f1574ece.svg";
export { ForwardRef as ReactComponent };